import { FC } from 'react';
import { ProButton } from '../antd';
import { ICON_COLLECTION } from '../constants/icon';
import { BaseOperationButtonProps } from './interface';

/** 新增按钮 */
const AddButton: FC<BaseOperationButtonProps> = props => {
  const { children, text, icon, ...restProps } = props;
  return (
    <ProButton icon={icon} {...restProps}>
      {children || text}
    </ProButton>
  );
};

AddButton.defaultProps = {
  icon: ICON_COLLECTION.ADD,
  text: '新增',
  type: 'primary',
};

export default AddButton;
